import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-star-atom',
  templateUrl: './star-atom.component.html',
  standalone: false,
})
export class StarAtomComponent {
  @Input() star!: string;
}
